import { h } from 'preact';
import register from '@wcd/preact-custom-element';
import { useState } from 'preact/hooks';
import { useContext } from './context';
import { LicenceUpgrade } from '../../../types/web-components';
import { emitClickUpgradeSchoolLicence } from '../shared/mz-helper';

const renderLink: any = ({ text, url, onClick }) => (
  <div>
    <a
      href={url}
      onClick={onClick}
      className="tds-btn tds-btn--lg tds-btn--block rdp-cta__secondary-btn tds-btn--secondary"
      rel="nofollow"
    >
      {text}
    </a>
  </div>
);

export const component: LicenceUpgrade = ({ resourceid }) => {
  const [owns, setOwns] = useState(false);
  const [isSchoolUpgradeAvailable, setIsSchoolUpgradeAvailable] = useState(false);
  const [licences, setLicences] = useState<string[]>([]);

  useContext(({
                currentLicences: { isSchoolUpgradeAvailable: isUpgradeAvailable, licences: currentLicences },
                user: { owns: ownsResource }
  }) => {
    setIsSchoolUpgradeAvailable(isUpgradeAvailable);
    setOwns(ownsResource);
    setLicences(currentLicences);
  });

  const LicenceWrapper = ({ children }) => (<div className='licence-wrapper mt-1 pt-1'>{children}</div>);
  const SchoolLicence = () => (<LicenceWrapper><span className='licence-base school-licence'>SCHOOL LICENCE</span></LicenceWrapper>);
  const IndividualLicence = () => (<LicenceWrapper>
      <span className='licence-base individual-licence'>INDIVIDUAL LICENCE</span>
      {renderLink({ text: 'Upgrade to school licence', url: `checkout/${resourceid}/upgrade`, onClick: emitClickUpgradeSchoolLicence })}
    </LicenceWrapper>);

  if (licences.length === 0) {
    return null;
  }

  if (owns && isSchoolUpgradeAvailable) {
    return <IndividualLicence />
  }

  return <SchoolLicence />;
};

register(component, 'licence-upgrade', ['resourceid'], { shadow: false });
